import {CMSAdmin} from '@/modules/cms';
import Modules from '@/modules/Modules';

export default {
  CMS: {
    exact: false,
    path: '/cms/admin',
    permissions: ['PAGE:WRITE'],
    component: CMSAdmin
  },
  Actors: {
    path: '/',
    component: Modules
  },
};
